import { render, staticRenderFns } from "./publicWeChatManageList.vue?vue&type=template&id=2dc066a8&scoped=true"
import script from "./publicWeChatManageList.vue?vue&type=script&lang=js"
export * from "./publicWeChatManageList.vue?vue&type=script&lang=js"
import style0 from "./publicWeChatManageList.vue?vue&type=style&index=0&id=2dc066a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc066a8",
  null
  
)

export default component.exports